import React, { useState } from "react";
import { Plus, Eye, Pencil } from "lucide-react";
import { Link } from "react-router-dom";

export default function HrEmployees() {
  const [employees] = useState([
    {
      id: 1,
      name: "John Doe",
      email: "john@example.com",
      department: "Sales",
      designation: "Sales Executive",
    },
    {
      id: 2,
      name: "Jane Smith",
      email: "jane@example.com",
      department: "HR",
      designation: "HR Manager",
    },
    {
      id: 3,
      name: "Robert Brown",
      email: "robert@example.com",
      department: "IT",
      designation: "Software Engineer",
    },
  ]);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-blue-700">Employee Directory</h1>

        <Link
          to="/hr/employees/add"
          className="px-4 py-2 bg-blue-600 text-white font-semibold rounded-lg shadow hover:bg-blue-700 flex items-center gap-2"
        >
          <Plus size={18} /> Add Employee
        </Link>
      </div>

      <div className="bg-white shadow-lg rounded-xl overflow-hidden">
        <table className="min-w-full border">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="p-3 border text-left">Name</th>
              <th className="p-3 border text-left">Email</th>
              <th className="p-3 border text-left">Department</th>
              <th className="p-3 border text-left">Designation</th>
              <th className="p-3 border text-center">Actions</th>
            </tr>
          </thead>

          <tbody>
            {employees.map((emp, idx) => (
              <tr
                key={idx}
                className="hover:bg-gray-50 transition border-b"
              >
                <td className="p-3">{emp.name}</td>
                <td className="p-3">{emp.email}</td>
                <td className="p-3">{emp.department}</td>
                <td className="p-3">{emp.designation}</td>

                <td className="p-3 flex justify-center gap-3">
                  <Link
                    to={`/hr/employees/view/${emp.id}`}
                    className="text-blue-600 hover:text-blue-800"
                  >
                    <Eye size={20} />
                  </Link>

                  <Link
                    to={`/hr/employees/edit/${emp.id}`}
                    className="text-green-600 hover:text-green-800"
                  >
                    <Pencil size={20} />
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
